import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Details from '../components/DesignDetail/Details'
import { loadSavedUserInspirationIds } from '../redux/actions/SaveInspirationAction'
import { count } from '../redux/communityReducers/DMReducer'
import { logEvent } from '../utils/firebase'

const DesignDetails = ({ initialPost, userDesigns, preloadedItems }) => {
  const dispatch = useDispatch()
  const auth = useSelector(state => state.auth)

  useEffect(() => {
    logEvent('design_view', {})
  }, [])

  useEffect(() => {
    dispatch(count())
  }, [dispatch])

  useEffect(() => {
    dispatch(loadSavedUserInspirationIds())
  }, [dispatch, auth])

  return <Details initialPost={initialPost} userDesigns={userDesigns} preloadedItems={preloadedItems} />
}

export default DesignDetails
